import MonitorIcon from '@mui/icons-material/Monitor';
import ScanIcon from '@mui/icons-material/Scanner';
import CloudIcon from '@mui/icons-material/CloudOutlined';
import UserIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import ExitIcon from '@mui/icons-material/ExitToApp';
import FileIcon from '@mui/icons-material/FileCopy';
import NotificationIcon from '@mui/icons-material/Notifications';
import DataIcon from '@mui/icons-material/Dataset';

const getMenuIcon = (id) => {
  if (id === 'keshif') return <MonitorIcon />;
  if (id === 'creator') return <CloudIcon />;
  if (id === 'users') return <GroupIcon />;
  if (id === 'user') return <UserIcon />;
  if (id === 'logout') return <ExitIcon />;
  if (id === 'moderation') return <ScanIcon />;
  if (id === 'newform') return <FileIcon />;
  if (id === 'notifications') return <NotificationIcon />;
  if (id === 'my-repositories') return <DataIcon />;
};

const menus = [
  {
    id: 'keshif',
    label: 'Dashboard',
    eligible: ['admin', 'contributor', 'editor', 'verificator'],
    icon: getMenuIcon('keshif'),
    navigate: '/',
    path: '/',
  },

  {
    id: 'moderation',
    label: 'Moderation',
    eligible: ['admin', 'editor', 'verificator'],
    icon: getMenuIcon('moderation'),
    navigate: 'moderation',
    path: '/portal/moderation',
  },
  {
    id: 'moderation',
    label: 'Moderation',
    eligible: ['admin', 'editor', 'verificator', 'contributor'],
    icon: getMenuIcon('moderation'),
    navigate: 'moderation/detail',
    path: '/portal/moderation/detail',
    isHidden: true,
  },
  {
    id: 'creator',
    label: 'Creator',
    eligible: ['admin'],
    icon: getMenuIcon('moderation'),
    navigate: 'portal/creator',
    path: '/portal/creator',
    isHidden: true,
  },
  {
    id: 'form',
    label: 'New Form',
    eligible: ['contributor', 'admin', 'editor', 'reviewer'],
    icon: getMenuIcon('newform'),
    navigate: '/form',
    path: '/form',
  },
  {
    id: 'my-repositories',
    label: 'My Repositories',
    eligible: ['contributor', 'admin', 'editor', 'reviewer'],
    icon: getMenuIcon('my-repositories'),
    navigate: '/portal/my-repositories',
    path: '/portal/my-repositories',
  },
  { id: 'user', label: 'Users', eligible: ['admin'], icon: getMenuIcon('user'), navigate: 'users', path: '/portal/users' },
  { id: 'registrations', label: 'Registrations', eligible: ['admin'], icon: getMenuIcon('user'), navigate: 'registrations', path: '/portal/registrations' },
  {
    id: 'notifications',
    label: 'Comments',
    eligible: ['contributor', 'admin', 'editor', 'reviewer'],
    icon: getMenuIcon('notifications'),
    navigate: 'notifications',
    path: '/portal/notifications',
  },
];

export default menus;
